module.exports = __webpack_public_path__ + "img/yuanjing.3e5e5a4f.png";